<div class="task-item-header">
    <div
        class="task-item-header-top"
        [class.task-item-header-top--stacked]="!!pauseTaskText()">
        <div class="task-item-header-title">{{ taskTitle }}</div>
        <div class="task-item-header-actions">
            @if (pauseTaskText(); as pauseText) {
                <a (click)="pauseTask.emit()">{{ pauseText }}</a>
            }
            @if (showCloseTask()) {
                <a (click)="onCloseLinkClick()">{{ closeTaskText() }}</a>
            }
        </div>
    </div>
    <div class="task-item-header-extra">
        <ng-content select="[task-item-header-extra]"></ng-content>
    </div>
</div>
<div class="task-item-content">
    <nz-spin
        [nzSpinning]="loading()"
        [nzDelay]="300"
        [nzTip]="loadingMessage()">
        <ng-content></ng-content>
    </nz-spin>
</div>
<div class="task-item-footer">
    <ng-content select="[task-item-footer]"></ng-content>
</div>

<ng-template #confirmCloseDrawer let-data let-drawerRef="drawerRef">
    <div class="confirm-close-drawer">
        <cpw-action-button
            actionLabel="{{ confirmCloseKeepLabel() }}"
            actionDescription="Stay on this task."
            actionIcon="undo"
            statusStyle="primary"
            (click)="drawerRef.close()">
        </cpw-action-button>
        <cpw-action-button
            actionLabel="{{ confirmCloseConfirmLabel() }}"
            actionDescription="Discard progress and leave."
            actionIcon="exceptions"
            statusStyle="danger"
            (click)="data.confirm(); drawerRef.close()">
        </cpw-action-button>
    </div>
</ng-template>
